module.exports = __webpack_public_path__ + "img/logo-light-small.955e4c2d.png";